export default __webpack_public_path__ + "static/frontend-2439fcb4912ef2a930b87017e1c2be99.svg";